import React, { useCallback } from 'react';

import useApiCall from '../../../services/useApiCall';
import useAPI from '../../../services/useAPI';
import { useTranslation } from '../../../localization/useTranslation';
import ConfirmDeleteModal from '../../Modals/ConfirmDeleteModal';
import useAlerts from '../../../utils/hooks/useAlerts';


const DeleteProvider = ({ confirmDeleteItem, onDelete, cancelDelete }) => {
  const T = useTranslation();
  const api = useAPI();
  const [alerts, , addErrorAlert] = useAlerts();

  const [confirmedDelete, isDeleting] = useApiCall({
    apiCall: api.core.deleteProvider,
    onSuccess: useCallback(() => {
      onDelete(confirmDeleteItem);
    }, [confirmDeleteItem, onDelete]),
    onError: useCallback((error) => {
      addErrorAlert(T.common.request.delete.failed);
      console.error(error);
    }, [T.common.request.delete.failed, addErrorAlert])
  });

  const onConfirmedDelete = useCallback((provider) => {
    confirmedDelete(provider.id);
  }, [confirmedDelete]);

  return (
    <>
      { alerts }
      <ConfirmDeleteModal
        isLoading={isDeleting}
        onConfirm={onConfirmedDelete}
        item={confirmDeleteItem}
        itemName={confirmDeleteItem?.displayName ?? T.common.noname}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default DeleteProvider;
